import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ExploreArtists() {
    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            {/* content begin */}
            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                {/* section begin */}
                <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Artists</h1>
                                    {/* <p>Anim pariatur cliche reprehenderit</p> */}
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* section close */}

                <section aria-label="section" id="section-artists">
                    <div className="container">
                        <div className="row">
                            <div className="d-item col-sm-6 col-md-4 col-lg-1-4">
                                <div class="owl-item active">
                                    <div class="nft_coll">
                                        <div class="nft_wrap">
                                        </div>
                                        <div class="nft_coll_ppp">
                                            <a href="/profile"><img class="lazy pp-coll" src="images/author/author-11.jpg" alt="" /></a>
                                        </div>
                                        <div class="nft_coll_info">
                                            <a href="/profile"><h3>@NFTtalks</h3></a>
                                            <span>100 NFT</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-item col-sm-6 col-md-4 col-lg-1-4">
                                <div class="owl-item active">
                                    <div class="nft_coll">
                                        <div class="nft_wrap">
                                        </div>
                                        <div class="nft_coll_ppp">
                                            <a href="/profile"><img class="lazy pp-coll" src="https://enftymart.themenio.com/html/images/thumb/avatar-3.jpg" alt="" /></a>
                                        </div>
                                        <div class="nft_coll_info">
                                            <a href="/profile"><h3>@NFTtalks</h3></a>
                                            <span>100 NFT</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-item col-sm-6 col-md-4 col-lg-1-4">
                                <div class="owl-item active">
                                    <div class="nft_coll">
                                        <div class="nft_wrap">
                                        </div>
                                        <div class="nft_coll_ppp">
                                            <a href="/profile"><img class="lazy pp-coll" src="https://enftymart.themenio.com/html/images/thumb/avatar-2.jpg" alt="" /></a>
                                        </div>
                                        <div class="nft_coll_info">
                                            <a href="/profile"><h3>@NFTtalks</h3></a>
                                            <span>100 NFT</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* content close */}

            {/* Footer */}
            <Footer />

        </div>
    );
}

export default ExploreArtists;